import { LogLevel, SegurancaConfiguration } from '@sigepe/ngx-sigepe-seguranca';

export class ConfigEnvironment {
	host_configuracao: string;
	host_eorg: string;
	security_hosts: string[];
	host_login_unico?: string;
	host_jsks?: string;
	host_api_sigepe?: string;
	client_id?: string;
	cookieDomain?: string;

	constructor(
		host_sigepe_ad_api: string,
		host_eorg: string,
		security_hosts: string[],
		host_login_unico?: string,
		host_jsks?: string,
		host_api_sigepe?: string,
		client_id?: string,
		cookieDomain?: string
	) {
		this.host_configuracao = host_sigepe_ad_api;
		this.host_eorg = host_eorg;
		this.security_hosts = security_hosts;
		this.host_login_unico = host_login_unico;
		this.host_jsks = host_jsks;
		this.host_api_sigepe = host_api_sigepe;
		this.client_id = client_id;
		this.cookieDomain = cookieDomain;
	}

	getEnvironment() {
		return {
			EVENTOS: `${this.host_configuracao}/eventos`,
			CICLO: `${this.host_configuracao}/gestor/ciclo`,
			CAD: `${this.host_configuracao}/gestor/cad`,
			ENUMERACAO: `${this.host_configuracao}/gestor/enumeracao`,
			RESULTADO_AVALIACAO: `${this.host_configuracao}/gestor/resultado-avaliacao`,
			SIAPE: `${this.host_configuracao}/gestor/siape`,
			ORGAOS: `${this.host_eorg}/orgao`,
			UORGS: `${this.host_eorg}/uorg`,
			DASHBOARD_GESTOR: `${this.host_configuracao}/gestor/v2`,
			CAD_COMMON: `${this.host_configuracao}/gestor/commons`,
			ANALISE_RECURSO: `${this.host_configuracao}/gestor/commons/analise-recurso`,
			ESTRUTURA_ORGANIZACIONAL: `${this.host_configuracao}/gestor/v2/commons/estrutura-organizacional`,
			ESTAGIO_PROBATORIO: `${this.host_configuracao}/gestor/v2/servidor-estagio-probatorio`,
			ESTAGIO_PROBATORIO_DASHBOARD: `${this.host_configuracao}/gestor/estagio-probatorio/dashboard`,
			RESULTADO_AVALIACAO_INSTITUCIONAL: `${this.host_configuracao}/gestor/v2/resultado-avaliacao-institucional`,
			RESULTADO_MONITORACAO_AVALIACAO_INDIVIDUAL: `${this.host_configuracao}/gestor/v2/monitoramento-resultados`,
			SEGURANCA_CONFIG: this.getConfiguracoesAutoriza(),
			EMPTY_PAGE: {
				content: [],
				page: { size: 0, number: 0, totalPages: 0, totalElements: 0 }
			},
			EMPTY_PAGE_AVALIACAO: {
				participantes: {
					content: [],
					page: { size: 0, number: 0, totalPages: 0, totalElements: 0 }
				},
				tiposAvaliacao: {
					possuiAvaliacaoChefe: false,
					possuiAvaliacaoAuto: false,
					possuiAvaliacaoPares: false,
					possuiAvaliacaoEquipe: false
				}
			}
		};
	}

	private getConfiguracoesAutoriza(): SegurancaConfiguration {
		const currentPath = window.location.pathname;
		const isCallback = currentPath.startsWith('/autorizacao');

		const seguranca_config: SegurancaConfiguration = {
			loginUnicoHost: this.host_login_unico,
			jwksHost: this.host_jsks,
			apiSigepeHost: this.host_api_sigepe,
			redirectUrl: `${window.location.protocol}//${window.location.host}/autorizacao`,
			postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}`,
			postLoginRoute: isCallback ? '/' : currentPath || '/',
			cookieDomain: this.cookieDomain,
			clientId: this.client_id,
			scope: 'openid+email+phone+profile+govbr_confiabilidades', // 'openid profile ' + your scopes
			sistemaOrigem: 'AVALIACAO_DESEMPENHO',
			responseType: 'code',
			silentRenew: false,
			renewTimeBeforeTokenExpiresInSeconds: 10,
			logLevel: LogLevel.Error,
			secureRoutes: this.security_hosts
		};
		return seguranca_config;
	}
}
